export var en = {
  DATE_PICKER_PLACEHOLDER: '00/00/0000 - 00/00/0000',
  DATE_PICKER_LAST_TAB: 'Last',
  DATE_PICKER_SINGLE_TAB: 'Specific',
  DATE_PICKER_RANGE_TAB: 'Range',
  DATE_PICKER_LAST_LABEL: 'Last {{count}} days',
  DATE_PICKER_LAST_OPTION_LABEL: '{{count}} days'
};